import React, { useState } from 'react';

const Twentyeighththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Crimson Tide */
            --primary: #991b1b;       /* Red 800 */
            --primary-light: #ef4444; /* Red 500 */
            --bg: #ffffff;
            --text-main: #1f2937;
            --gray: #f3f4f6;
        }

        body { font-family: 'Anton', sans-serif; letter-spacing: 1px; margin: 0; color: var(--text-main); }
        .body-font { font-family: 'Open Sans', sans-serif; letter-spacing: normal; }
        
        .container { max-width: 1100px; margin: 0 auto; padding: 0 20px; }
        
        .header { background: var(--primary); color: white; padding: 15px 0; }
        .header .container { display: flex; justify-content: space-between; align-items: center; }
        .logo { font-size: 1.5rem; text-transform: uppercase; letter-spacing: 2px; }
        
        .hero { display: flex; align-items: center; background: #fee2e2; padding: 50px; margin: 20px auto; max-width: 1200px; border-radius: 20px; }
        .hero-text { flex: 1; padding-right: 40px; }
        .hero h1 { font-size: 4rem; margin: 0 0 20px; line-height: 1; color: var(--primary); text-transform: uppercase; }
        .hero p { font-size: 1.1rem; color: #4b5563; margin-bottom: 30px; letter-spacing: 0; }
        .hero-img { flex: 1; height: 300px; background: white; border-radius: 20px; overflow: hidden; display: flex; align-items: center; justify-content: center; color: #ccc; }
        
        .btn { background: var(--primary); color: white; border: none; padding: 15px 40px; font-family: 'Anton', sans-serif; font-size: 1.2rem; text-transform: uppercase; cursor: pointer; transform: skew(-10deg); transition: 0.2s; }
        .btn:hover { background: var(--primary-light); }
        
        .section-header { text-align: center; margin: 80px 0 50px; }
        .section-header h2 { font-size: 3rem; margin: 0; text-transform: uppercase; color: var(--primary); position: relative; display: inline-block; }
        .section-header h2::after { content: ''; position: absolute; width: 100%; height: 10px; background: rgba(239, 68, 68, 0.2); bottom: 5px; left: 0; z-index: -1; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 40px; }
        
        .service-card { background: white; padding: 30px; border: 2px solid #e5e7eb; transition: 0.2s; position: relative; overflow: hidden; }
        .service-card:hover { border-color: var(--primary); box-shadow: 10px 10px 0 var(--primary); transform: translate(-5px, -5px); }
        .card-icon { font-size: 3rem; color: var(--primary-light); margin-bottom: 20px; }
        
        .product-card { border: 2px solid #e5e7eb; }
        .product-img { height: 250px; background: #f9fafb; display: flex; align-items: center; justify-content: center; overflow: hidden; }
        .product-img img { width: 100%; height: 100%; object-fit: cover; }
        
        .footer { background: #111; color: white; padding: 60px 0; text-align: center; margin-top: 100px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Anton&family=Open+Sans:wght@400;600&display=swap" rel="stylesheet" />

            <div className="header">
                <div className="container">
                    <div className="logo">{get_data.service_name}</div>
                    <div className="body-font" style={{fontSize: '0.9rem', fontWeight: 600}}>
                        <a href="#contact" style={{color: 'white'}}>CONTACT US</a>
                    </div>
                </div>
            </div>

            <div className="hero">
                <div className="hero-text">
                    <h1>Strength.<br/>Passion.<br/>Power.</h1>
                    <p className="body-font">Unleash the potential of your business with our robust solutions. We deliver impact that lasts.</p>
                    <button className="btn">Start Now</button>
                </div>
                <div className="hero-img">
                    <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" style={{width: '100%', height: '100%', objectFit: 'cover'}} alt="Impact"/>
                </div>
            </div>

            <div className="container" id="services">
                <div className="section-header"><h2>Services</h2></div>
                <div className="grid">
                    {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="service-card" key={index}>
                            <div className="card-icon">
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '60px', height: '60px', objectFit: 'contain'}} alt=""/> : <span>★</span>}
                            </div>
                            <h3>{item.name}</h3>
                            <p className="body-font" style={{color: '#666', lineHeight: 1.6}}>{item.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container" id="products">
                 <div className="section-header"><h2>Store</h2></div>
                 <div className="grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                         <div className="product-card" key={index}>
                             <div className="product-img">
                                 <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} alt={item.service_name}/>
                             </div>
                             <div style={{padding: '20px'}}>
                                 <h3>{item.service_name}</h3>
                                 {item.price && <div className="body-font" style={{fontSize: '1.2rem', fontWeight: 'bold', color: 'var(--primary)', margin: '10px 0'}}>₹{item.price}</div>}
                                 <button onClick={() => addToCart(item)} className="btn" style={{fontSize: '1rem', padding: '10px 30px', transform: 'skew(0)'}}>Add</button>
                             </div>
                         </div>
                     ))}
                 </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <h2 style={{margin: '0 0 20px'}}>{get_data.service_name}</h2>
                    <p className="body-font" style={{opacity: 0.7}}>{get_data.business_location_name}</p>
                    <p className="body-font" style={{opacity: 0.7}}>{get_data.mobile}</p>
                </div>
            </footer>
        </>
    );
};

export default Twentyeighththeme;
